import { render, staticRenderFns } from "./FormInputReservationLimitType.vue?vue&type=template&id=1872854c&scoped=true&lang=pug"
import script from "./FormInputReservationLimitType.vue?vue&type=script&lang=ts"
export * from "./FormInputReservationLimitType.vue?vue&type=script&lang=ts"
import style0 from "./FormInputReservationLimitType.vue?vue&type=style&index=0&id=1872854c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1872854c",
  null
  
)

export default component.exports